import { evaluateCalEventTemplate } from './evaluate-cal-event-template.js';
/** Re-evaluates without the values of fields the rules hide until visibility stops changing. */
export function evaluateSettledCalEventTemplate(input) {
    const fieldIds = new Set(input.fields.map((field) => field.id));
    let evaluation = evaluateCalEventTemplate(input);
    for (let pass = 0; pass < input.fields.length; pass += 1) {
        const visibleValues = Object.fromEntries(Object.entries(input.values).filter(([fieldId]) => !fieldIds.has(fieldId) || evaluation.visible[fieldId]));
        const next = evaluateCalEventTemplate({ ...input, values: visibleValues });
        const settled = input.fields.every((field) => Boolean(next.visible[field.id]) === Boolean(evaluation.visible[field.id]));
        evaluation = next;
        if (settled)
            break;
    }
    return evaluation;
}
//# sourceMappingURL=evaluate-settled-cal-event-template.js.map